import type { UpdateUserBody } from "@shared-kernel/application/ports/shared/shared-repository";
import { createAction, createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";

export const updateUser = createAsyncThunk<void, UpdateUserBody, { extra: Partial<Dependencies> }>(
  "users/updateUser",
  async (body: UpdateUserBody, { extra: { sharedRepository } }) => {
    return sharedRepository!.update(body);
  },
);

export const resetUpdateUser = createAction("users/resetUpdateUser");
